<template>
  <main class="page">
    <section class="section page__header">
      <h1 class="title">Список сотрудников</h1>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__search">
            <SearchForm
              :value="searchValue"
              @form-submit="setUsersSearchValue"
            />
          </div>
          <AppButtonFilter
            :active="filterIsActive"
            @click.native="toggleFilter"
          />
        </div>
        <div class="page__item" v-if="roleAccessCreateUser">
          <div class="page__row">
            <transition name="fade" v-if="roleAccessRemove">
              <div class="page__item" v-if="isActiveDelete">
                <AppButtonSmRemove
                  title="Удалить"
                  @click.stop.native="showRemoveConfirmationGroup"
                />
              </div>
            </transition>
              <AppButtonSmAdd title="Создать" @click.native="createUserPage" />
          </div>
        </div>
      </div>

      <!--   Filter   -->
      <transition name="fade">
        <Form
          v-model="filterData"
          @request="setFilter"
          ref="filterForm"
          v-if="filterIsActive"
          class="filter"
        >
          <div class="filter__list">
            <AppInputDate title="Дата рождения"
                          name="birthDate"
                          type="range"
            />
            <AppInputDate title="Дата приема"
                          name="startDate"
                          type="range"
            />
            <AppSelect title="Подразделение"
                       placeholder="Укажите подразделение"
                       name="department"
                       :options="departmentList"
            />
            <AppSelect title="Должность"
                       placeholder="Укажите должность"
                       :value="filter.position"
                       name="position"
                       :options="positionList"
            />
            <AppSelect title="Вид занятости"
                       placeholder="Укажите вид занятости"
                       :value="filter.employment"
                       name="employment"
                       :options="employmentList"
            />
            <AppSelect title="Статус"
                       placeholder="Укажите статус"
                       :value="filter.status"
                       name="status"
                       :options="statusList"
            />
            <AppCheckbox
              title="Есть дети"
              :checked="has_children"
              @toggle-check="has_children = !has_children"
            />
          </div>
          <div class="filter__buttons">
            <AppButton
              type="main"
              title="Показать"

            />
            <AppButton
              type="alt"
              title="Сбросить"
              @click.stop.native="clearFilter"
            />
          </div>
        </Form>
      </transition>

      <!--   Table   -->
      <div class="page__table mb-20" v-if="users.length !== 0">
        <AppTable
          :data="users"
          :headers="tableHeaders.headers"
          :has-checkbox="roleAccessRemove"
          :loading="isTableLoading"
          @show-this-item="openUserDetail"
          isSpecial
          @toggle-active-item="toggleActiveItem"
          @toggle-active-all="toggleActiveAll"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer user-list__footer">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation
        v-if="removeConfirmation.active"
        :text="
          removeConfirmation.group
          ? 'Вы действительно хотите удалить этих сотрудников?'
          : 'Вы действительно хотите удалить этого сотрудника?'
        "
        @confirm="deleteUsersChecked()"
        @reject="closeModalRemove"
      />

      <AppModal
        v-if="deleteResponseModal.isActive"
        :title="deleteResponseModal.title"
        :text="deleteResponseModal.text"
        confirmButtonTitle="Ок"
        :confirmButtonType="deleteResponseModal.type"
        @confirm="closeDeleteModal"
      />
    </transition>
    <ThePagePreloader v-if="userListPageIsLoading"/>
  </main>
</template>

<script>
import AppTable from '../../components/page/table/AppTable'
import SearchForm from '../../components/page/input/SearchForm'
import AppConfirmation from '../../components/page/modal/AppConfirmation'
import AppButtonSmAdd from '../../components/page/button/AppButtonSmAdd'
import ThePagePreloader from '../../components/page/ThePagePreloader'
import AppNoRecordsPlaceholder from '../../components/page/text/AppNoRecordsPlaceholder'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppSelect from '@/components/page/input/AppSelect'
import AppButtonFilter from '@/components/page/button/AppButtonFilter'
import AppButton from '@/components/page/button/AppButton'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppModal from '@/components/page/modal/AppModal'
import VPagination from '@/components/page/VPagination'
import Form from '@/components/page/Form/Form'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'UserList',
  components: {
    Form,
    AppNoRecordsPlaceholder,
    ThePagePreloader,
    AppButtonSmAdd,
    AppConfirmation,
    AppModal,
    SearchForm,
    AppButtonSmRemove,
    AppTable,
    AppSelect,
    VPagination,
    AppInputDate,
    AppCheckbox,
    AppButton,
    AppButtonFilter
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      },
      // фильтр
      filterIsActive: false,
      filterData: {},
      has_children: false
    }
  },
  mounted () {
    this.loadOptions()
  },
  computed: {
    ...mapState({}),

    ...mapGetters({
      statusList: '[dictionaries] usersStatusList',
      departmentList: '[dictionaries] usersDepartmentList',
      positionList: '[dictionaries] usersPositionList',
      employmentList: '[dictionaries] usersEmploymentList'
    }),
    ...mapGetters('userListPage', [
      'userListPageIsLoading',
      'isTableLoading',
      'deleteResponseModal',
      'searchValue',
      'filter',
      'isActiveDelete',
      'allUsers',
      'tableHeaders',
      'pagination'
    ]),
    users () {
      return this.allUsers.map(user => {
        return {
          id: user.id,
          isActive: user.isActive,
          values: [
            { data: user || {}, mod: 'avatar' },
            { data: user || {}, mod: 'status' },
            user.phone,
            user.email,
            user.position ? user.position.name : 'Не указана',
            user.department ? user.department.name : '-'
          ]
        }
      })
    },

    roleAccessCreateUser () {
      return this.$store.getters.getRoleRightsUsers.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    },
    roleAccessUserControls () {
      return this.$store.getters.getRoleRightsUsers.actionAccess
    },
    roleAccessUserActions () {
      // нужно в любом случае исключать "добавить", потому что создание через отдельную кнопку
      return { ...this.$store.getters.getRoleRightsUsers.actions, add: false }
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getStatusList')
      this.$store.dispatch('[dictionaries] getDepartmentList')
      this.$store.dispatch('[dictionaries] getPositionList')
      this.$store.dispatch('[dictionaries] getEmploymentList')
      this.$store.dispatch('userListPage/getUsers')
    },

    createUserPage () {
      this.$router.push({ path: '/user/create' })
    },
    updateUser (userId) {
      this.$router.push({ path: `/user/update/${userId}` })
    },

    deleteUsersChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('userListPage/deleteUserListCheckedItems')
      this.removeConfirmation.group = false
    },

    closeDeleteModal () {
      this.$store.dispatch('userListPage/closeUserListDeleteModal')
    },
    closeModalRemove () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.removeConfirmation.group = false
    },

    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },

    closeModal () {
      this.removeConfirmation.id = null
      this.$store.dispatch('userListPage/toggleUserListItemControls', null)
    },

    openUserDetail (userId) {
      this.$router.push({ path: `/user/info/${userId}/personal` })
    },

    // table
    toggleActiveItem (itemId) {
      this.$store.dispatch('userListPage/toggleUsersListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('userListPage/toggleUsersListItemActiveAll')
    },

    // search
    setUsersSearchValue (searchValue) {
      this.$store.dispatch('userListPage/setUsersSearchValue', searchValue)
    },

    // filter
    toggleFilter () {
      this.filterIsActive = !this.filterIsActive
    },
    closeFilter () {
      this.$store.dispatch('userListPage/closeUserListFilter')
    },
    setFilter (data) {
      const birthDataStart = data.birthDate ? data.birthDate.split(' / ').shift() : ''
      const birthDataEnd = data.birthDate ? data.birthDate.split(' / ').pop() : ''
      const employmentDataStart = data.startDate ? data.startDate.split(' / ').shift() : ''
      const employmentDataEnd = data.startDate ? data.startDate.split(' / ').pop() : ''

      const filter = {
        birthFrom: birthDataStart,
        birthTo: birthDataEnd,
        employmentFrom: employmentDataStart,
        employmentTo: employmentDataEnd,
        department: data.department?.name,
        position: data.position?.name,
        employment: data.employment?.name,
        status: data.status?.name,
        is_child: this.has_children ? 1 : ''
      }
      this.$store.commit('userListPage/SET_USER_LIST_FILTER', filter)
      this.$store.dispatch('userListPage/getUsersListPage', 1)
      this.$store.dispatch('userListPage/getUsers')
    },
    clearFilter () {
      this.$refs.filterForm.clear()
      this.$store.commit('userListPage/CLEAR_USER_LIST_FILTER', {})
      this.$store.dispatch('userListPage/getUsers')
    },
    getPage (pageNum) {
      this.$store.dispatch('userListPage/getUsersListPage', pageNum)
    }
  },

  destroyed () {
    this.$store.commit('userListPage/RESET_USER_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.page__search {
  margin-right: 16px;
}
.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
